<mat-icon id="close" (click)="close()">close</mat-icon>
<h1>{{ 'SETTINGS.EMAIL_SETTINGS.UPLOAD_HEADER_IMAGE.HEADER' | translate }}</h1>
<mat-tab-group>
  <mat-tab label="{{ 'SETTINGS.EMAIL_SETTINGS.UPLOAD_HEADER_IMAGE.SELECT_FROM_PHOTO_LIBRARY' | translate }}">
    <div class="default-images">
      @for (url of imageUrls; track url) {
      <img [src]="url" (click)="selectImage(url)" />
      }
    </div>
  </mat-tab>
  @if (displayUploadTab) {
  <mat-tab label="{{ 'SETTINGS.EMAIL_SETTINGS.UPLOAD_HEADER_IMAGE.UPLOAD_CUSTOM_PHOTO' | translate }}">
    <app-image-uploader-editor
      #customImageUpload
      [uploadUrl]="data.uploadUrl"
      id="modal-image-uploader"
      [aspects]="aspects"
      (uploadedFile)="customImageUploaded($event)"
    ></app-image-uploader-editor>
    <div id="recommendations">
      <div>{{ 'SETTINGS.EMAIL_SETTINGS.UPLOAD_HEADER_IMAGE.HEADER_DIMENSIONS' | translate }}</div>
      <div>{{ 'SETTINGS.EMAIL_SETTINGS.UPLOAD_HEADER_IMAGE.FILE_TYPES' | translate }}</div>
    </div>
  </mat-tab>
  }
</mat-tab-group>
